<template>
	<div
		ref="clipSearchInput"
		class="clip-search-input"
	>
		<input
			ref="input"
			v-model="searchInput"
			class="search-input"
			:placeholder="labels.placeholder"
		>
		<div
			class="caret"
		>
			<Icon
				:icon-name="iconName"
				size="sm"
				:class="`remove-icon-color ${searchInput ? '' : 'disabled'}`"
				@click="onCloseClick"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name:  'ClipSearchInput',
	props: {
		searchKeyword: {
			type: String,
		},
		placeholder: {
			type: String,
		},
		iconName: {
			type:    String,
			default: 'e-remove',
		},
	},
	data() {
		return {
		};
	},
	computed: {
		...mapGetters({
			isMobileWebApp: 'app/isMobileWebApp',
		}),
		labels() {
			return {
				placeholder: this.placeholder || this.transUcfirst('commons.search'),
			};
		},
		searchInput: {
			get() { return this.searchKeyword; },
			set(value) { this.$emit('change', value); },
	 },
	},
	mounted() {
		this.$refs.input.focus();
		setTimeout(() => document.addEventListener('click', this.onDocumentClick), 1000);
	},
	destroyed() {
		document.removeEventListener('click', this.onDocumentClick);
	},
	methods: {
		onDocumentClick(event) {
			if (!this.isMobileWebApp &&
				event.target && this.$refs.clipSearchInput &&
				!this.$refs.clipSearchInput.contains(event.target) &&
				!this.searchKeyword?.length
			) {
				this.$emit('close');
			}
		},
		onCloseClick() {
			this.$emit('close');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import "@videotools/sass/_fonts.scss";

.clip-search-input {
	display: flex;
	border-radius: 24px;
	background: var(--color-grey-900);
	padding: 10px 16px;
	width: 100%;
	justify-content: space-between;

	::placeholder {
		color: var(--color-grey-600);
	}

	.is-mobile & {
		padding: 8px 16px;
	}

	.search-input {
		flex: 1 1 0;
		max-width: 88%;
		@include text-md-1;
	}

	.caret {
		cursor: pointer;
		display: flex;
		align-items: center;
	}

	@media(hover:hover) {
		&:hover {
			background: var(--color-grey-850);
		}
	}
}

</style>
